var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("扫描成功，正在跳转，请稍候... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }